import { lazy, Suspense } from "react";

const Loadable = (Component) => (props) =>
(
    <Suspense fallback={<>Please Wait...</>}>
        <Component {...props} />
    </Suspense>
);

const Home = Loadable(lazy(() => import("./components/Home")));
const AboutUs = Loadable(lazy(() => import("./components/AboutUs")));
const Careers = Loadable(lazy(() => import("./components/Careers")));
const ContactUs = Loadable(lazy(() => import("./components/ContactUs")));
const OurStories = Loadable(lazy(() => import("./components/OurStories")));
const ProductDetails = Loadable(lazy(() => import("./components/ProductDetails")));
const ProductList = Loadable(lazy(() => import("./components/ProductList")));
const RecipesDetails = Loadable(lazy(() => import("./components/RecipesDetails")));
const RecipesList = Loadable(lazy(() => import("./components/RecipesList")));
const InvalidRoutes = Loadable(lazy(() => import("./components/InvalidRoutes")));

const routes = [
    {
        path: "/",
        element: (
            <Home />
        ),
    },
    {
        path: "/about-us",
        element: (
            <AboutUs />
        ),
    },
    // {
    //     path: "/careers",
    //     element: (
    //         <Careers />
    //     ),
    // },
    {
        path: "/contact-us",
        element: (
            <ContactUs />
        ),
    },
    {
        path: "/our-stories",
        element: (
            <OurStories />
        ),
    },
    {
        path: "/product-details/:id",
        element: (
            <ProductDetails />
        ),
    },
    {
        path: "/product-list",
        element: (
            <ProductList />
        ),
    },
    // {
    //     path: "/recipes-details/:id",
    //     element: (
    //         <RecipesDetails />
    //     ),
    // },
    // {
    //     path: "/recipes-list",
    //     element: (
    //         <RecipesList />
    //     ),
    // },
    {
        path: "*",
        element: (
            <InvalidRoutes />
        )
    }
]

export default routes;